import { watchEffect } from "@vue/composition-api";
import { status } from "@/config";
import { isLoggedIn } from "@micad/vue-components";
import { userInfo } from "@/modules/auth";
import { getIntercomToken } from "@/data/repos/userInfo";
import Intercom, { shutdown } from '@intercom/messenger-js-sdk'


export const init = () => {
  watchEffect(async () => {
    if (status.loaded) {
      // Intercom initialization
      const intercomToken = await getIntercomToken();
      if (intercomToken) {
        Intercom({
          app_id: 'h22j37nc',
          region: 'eu',
          intercom_user_jwt: intercomToken,
          Support_Login_Token: true,
          Domain: window.location.hostname,
        })
      }
    }
  });

  watchEffect(() => {
    if (!isLoggedIn.value || !userInfo.userId) {
      shutdown() // Shutdown Intercom when user is not logged in
    } 
  });
};
